import { combineReducers } from 'redux';

import snackBarReducer from './snackbar/reducer';

export default combineReducers({
  snackBar: snackBarReducer
});
